var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/2796ed81999693.5d10c0872415e.gif"),"alt":"loading...","width":"250"}})])
}]

export { render, staticRenderFns }